import { z } from "zod";
import { DistanceSchema } from "./race";

export const RunnerLevelSchema = z.enum(["beginner", "intermediate", "advanced", "elite"]);
export type RunnerLevel = z.infer<typeof RunnerLevelSchema>;

export const UserProfileSchema = z.object({
  userId: z.string().uuid(),
  level: RunnerLevelSchema.nullable(),
  pace5kSec: z.number().int().min(600).max(3600).nullable(),
  pace10kSec: z.number().int().min(1200).max(7200).nullable(),
  paceHalfSec: z.number().int().min(2400).max(14400).nullable(),
  paceFullSec: z.number().int().min(5400).max(28800).nullable(),
  preferredDistances: z.array(DistanceSchema),
  preferredRegions: z.array(z.string()),
  bio: z.string().max(500).nullable(),
  updatedAt: z.number().int(),
});
export type UserProfile = z.infer<typeof UserProfileSchema>;

export const UserProfileInputSchema = UserProfileSchema.omit({
  userId: true,
  updatedAt: true,
}).partial();
export type UserProfileInput = z.infer<typeof UserProfileInputSchema>;
